<script setup lang="ts">
import { VIcon } from '@/modules/shared/components'

withDefaults(
  defineProps<{
    disabled?: boolean
    tooltip?: string
    href?: string | null
    icon?: string
    loading?: boolean
    tag?: string
    target?: string
    text: string
    to?: any
  }>(),
  {
    disabled: false,
    tooltip: '',
    href: null,
    loading: false,
    tag: 'button',
    target: '_self',
  },
)
</script>

<template>
  <component class="block w-full text-left" :disabled="disabled" :href="href" :is="tag" :target="target" :to="to">
    <label
      class="group flex w-full items-center justify-between space-x-2 px-4 py-2 text-sm font-medium"
      :class="{
        'cursor-pointer text-gray-700 hover:bg-gray-800 hover:text-gray-200': !disabled,
        'cursor-not-allowed bg-gray-50 text-gray-400': disabled,
      }"
      :title="tooltip"
    >
      <div v-if="!loading" class="flex w-full items-center justify-between space-x-2">
        <span>{{ text }}</span>
        <span>
          <VIcon
            v-if="icon"
            :name="icon"
            class="h-4 w-4 text-gray-500 group-hover:text-gray-400 group-[.cursor-not-allowed]:text-gray-300"
          />
        </span>
      </div>
      <div v-else class="mx-auto w-fit">
        <VIcon name="Loading" class="h-4 w-4 animate-spin-fast" />
      </div>
      <slot />
    </label>
  </component>
</template>
